import { PANEL_TRANSITION_MS } from '../constants/panel-animation';

/**
 * Rate-limits a slide-in panel's toggle to one action per transition, so a fast double-click
 * can't make the panel flap open-closed.
 *
 * Returns a predicate that reports whether this toggle should proceed — and records the attempt
 * when it does, so callers must invoke it exactly once per click.
 */
export function createPanelToggleGuard(): () => boolean {
  let lastToggleAt = 0;

  return () => {
    const now = Date.now();

    if (now - lastToggleAt < PANEL_TRANSITION_MS) {
      return false;
    }

    lastToggleAt = now;

    return true;
  };
}
